import { Card, CardProps, useMantineTheme } from '@mantine/core';
import { useMemo } from 'react';
import { getContrastingTextColor } from '../../utils/color';

interface GradientCardProps extends CardProps {
  variantName?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'success'
    | 'info'
    | 'warning'
    | 'danger';
}

export default function GradientCard({
  variantName = 'primary',
  children,
  style,
  ...rest
}: GradientCardProps) {
  const theme = useMantineTheme();
  const gradient = theme.other.gradients[variantName];

  // Calculate text color for gradient background
  const gradientBg = `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`;
  const autoTextColor = useMemo(
    () => getContrastingTextColor(gradientBg),
    [gradientBg]
  );

  return (
    <Card
      radius="lg"
      p="lg"
      style={{
        backgroundImage: gradientBg,
        color: style?.color || autoTextColor,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Card>
  );
}
